<template>
  <div>
    <el-dialog title="提示" :before-close="handleClose" width="500px" :visible.sync="showExamination" class="examination"
      :close-on-click-modal="false" :modal-append-to-body='false' :append-to-body="true" top='300px' center>
      <div class='weekBox'>
        <span>您还没有通过准入考核，考核合格后才能预约设备。是否现在进行考试？</span>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="detail_save">好的，现在考</el-button>
        <el-button @click="handleClose">不要，等一会</el-button>

      </span>
    </el-dialog>
    <admissionExamination v-if='showadmissionExamination' :showadmissionExamination='showadmissionExamination'
      @close='closeadmissionExamination'>
    </admissionExamination>
  </div>
</template>
<script>
export default {
  props: {
    showExamination: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showadmissionExamination: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    detail_save() {
      this.showadmissionExamination = true
    },
    closeadmissionExamination() {
      this.showadmissionExamination = false
      this.handleClose()
    }
  },
  created() {
  }
}
</script>
<style lang="scss" scoped>
::v-deep.examination {
  .el-dialog__header {
    border-bottom: 1px #d7dce0 solid;
    padding: 0 0;
    height: 56px;
    line-height: 56px;
    font-weight: 800;
    color: black;

    // color: rgb(76, 110, 184);
    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        font-size: 24px;
      }
    }
  }

  .el-table tr td {
    height: 60px;
  }
}
</style>